// 项目案例数据（分类元信息 + 各分类项目列表）
// 图片通过 require 引入，便于 webpack 处理；假项目封面走 text_to_image 接口。

const img = (prompt, size = "landscape_4_3") =>
  "https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=" +
  encodeURIComponent(prompt) +
  "&image_size=" +
  size;

export const categories = [
  {
    slug: "custom",
    name: "定制化软件",
    desc: "按业务流程量身设计，从需求到交付全链路工程化。",
  },
  {
    slug: "website",
    name: "企业官网",
    desc: "品牌展示与对外门户，兼顾形象与信息架构，兼顾多端访问与搜索引擎可见性。",
  },
  {
    slug: "miniapp",
    name: "微信小程序",
    desc: "轻量移动端应用，触达现场人员与公众用户，即用即走。",
  },
  {
    slug: "industrial",
    name: "工业化软件",
    desc: "面向工业现场的监控、调度与设备集成系统，稳定可靠。",
  },
  {
    slug: "app",
    name: "应用程序",
    desc: "跨平台应用交付，覆盖桌面、移动与现场终端。",
  },
];

export const projectMap = {
  website: [

    {
      name: '"互联网+智慧监管"',
      type: "政务官网",
      desc: "识别农贸市场占道经营、违章停车等事件，并通过派单管理方式下达各站点负责人处置。",
      tags: ["智慧监管", "事件识别", "派单管理"],
      client: "市场监管局",
      year: "2023",
      img: require("@/assets/jinpin/one.png"),
      gallery: [
        require("@/assets/jinpin/one.png"),
        require("@/assets/jinpin/tow.png"),
        require("@/assets/jinpin/thress.png"),
      ],
      detail:
        '"互联网+智慧监管"平台整合市场内外现有监控资源，通过视频转码、视频分析技术，自动识别农贸市场占道经营、违章停车等违规事件，识别结果以智能派单形式直达各站点负责人，实现发现、处置、复核全流程闭环，大幅提升基层监管效率。',
      highlights: [
        "视频转码与AI识别：占道经营 / 违章停车 自动识别",
        "智能派单闭环：识别→派单→处置→复核全流程留痕",
        "GIS事件一张图：实时定位违规点位与处置进度",
        "多端联动：监管大屏 + 站点负责人APP协同",
      ],
    },
        {
      name: "绿王新材料",
      type: "企业官网",
      desc: "广东绿王新材料有限公司官网，PETG/RPETG 热收缩膜环保型聚酯薄膜生产企业的品牌展示与对外门户。",
      tags: ["企业官网", "热收缩膜", "PETG", "环保材料"],
      client: "广东绿王新材料有限公司",
      year: "2022",
      img: require("@/assets/dzh/lw/lw.png"),
      gallery: [require("@/assets/dzh/lw/lw.png")],
      detail:
        "广东绿王新材料有限公司官网，服务于这家位于广东省汕头市的聚酯薄膜环保型生产企业。公司工厂占地 20000 平方米，年产 PETG、RPETG 等热收缩膜 8000 吨，主营透明与乳白色 PETG（RPETG）热收缩膜，广泛应用于啤酒、饮料、医药、日化及各类工业品容器的集束包装与高价值标签。官网承载品牌形象展示、产品介绍、企业实力与资质认证等信息，为全球客户提供一站式了解绿王材料的入口。",
      highlights: [
        "专业化企业：占地 2 万㎡ / 年产 8000 吨 / 聚酯薄膜环保型生产企业",
        "专业化团队：自主研发团队 + 数字化品控 + 近 30 年行业经验",
        "产品体系：透明 / 乳白 PETG(RPETG) 热收缩膜，收缩率 >75%",
        "业务遍布广：畅销全国并出口欧洲、美洲、中东及亚洲各国",
        "资质认证：ISO9001 国际质量体系 + GRS 全球回收标准认证",
        "知名终端客户：达能、怡宝、东鹏特饮、喜茶、迪士尼、环球影院等",
      ],
    },
    {
      name: "田心中学",
      type: "学校官网",
      desc: "汕头市潮南区田心中学学校官网，集学校简介、校园新闻、通知公告、师资力量、校园风采与招生招聘于一体的对外门户。",
      tags: ["学校官网", "校园新闻", "师资力量", "招生招聘"],
      client: "汕头市潮南区田心中学",
      year: "2023",
      img: require("@/assets/dzh/txzx/sy.png"),
      gallery: [
        require("@/assets/dzh/txzx/sy.png"),
        require("@/assets/dzh/txzx/gs.png"),
        require("@/assets/dzh/txzx/xw.png"),
        require("@/assets/dzh/txzx/gg.png"),
        require("@/assets/dzh/txzx/zp.png"),
      ],
      detail:
        "田心中学官网是汕头市潮南区田心中学（田心华侨中学）的学校官方网站，围绕「学校简介→校园新闻→通知公告→师资力量→校园风采→招生招聘」构建对外信息架构。师生、家长与社会公众可在官网内了解学校概况与办学理念、查看校园新闻与通知公告、认识校领导与师资团队、品鉴校园风采与教学教研成果，并获取招生招聘信息，是学校对外宣传与家校沟通的统一窗口。",
      highlights: [
        "学校简介：办学概况 / 办学理念 / 联系方式",
        "校园新闻：学校动态 / 活动赛事 / 资讯发布",
        "通知公告：招生录取 / 致家长信 / 公告通知",
        "师资力量：校领导与骨干教师团队展示",
        "校园风采：校门 / 礼堂 / 运动场 / 教学楼等风貌",
        "招生招聘：招生信息与教师招聘发布入口",
      ],
    },
    {
      name: "汕头大学精神卫生中心",
      type: "医院官网",
      desc: "汕头大学精神卫生中心医院官网，集医院介绍、专家团队、新闻动态、护理与教学培训、临床研究与受试者招募于一体的对外门户。",
      tags: ["医院官网", "精神卫生", "专家团队", "临床研究"],
      client: "汕头大学精神卫生中心",
      year: "2024",
      img: require("@/assets/dzh/stdx/sy.png"),
      gallery: [
        require("@/assets/dzh/stdx/sy.png"),
        require("@/assets/dzh/stdx/yyjs.png"),
        require("@/assets/dzh/stdx/zjts.png"),
      ],
      detail:
        "汕头大学精神卫生中心官网是医院的官方对外门户，围绕「医院介绍→专家团队→新闻动态→护理与教学→临床研究」构建对外信息架构。患者与公众可在官网内了解医院概况与就诊指南、认识精神科专家团队、查看医院新闻与通知公告、了解护理质量安全与教学培训（精神专科护士高级研修班、精神科医师转岗培训、高校辅导员心育培训等）、并获取临床研究受试者招募信息，是医院对外宣传、医患沟通与学术交流的统一窗口。",
      highlights: [
        "医院介绍：医院概况 / 就诊指南 / 咨询与急诊电话",
        "专家团队：精神科专家与科室团队展示",
        "新闻动态：医院资讯 / 表彰活动 / 通知公告",
        "护理与教学：护理质量安全 + 专科护士/医师培训",
        "临床研究：受试者招募与临床研究信息发布",
        "医患沟通：预约咨询 + 急诊电话一站式入口",
      ],
    },
  ],
  miniapp: [
    {
      name: "低碳游",
      type: "微信小程序",
      desc: "以低碳环保为核心理念的微信小程序，围绕打卡、积分、商城、商家、回收、学习场景，形成「行为→积分→权益」闭环。",
      tags: ["低碳", "积分", "打卡", "团长分销"],
      client: "中国联通",
      year: "2026",
      img: require("@/assets/wxxcx/dt/dtsy.jpg"),
      gallery: [
        require("@/assets/wxxcx/dt/dtsy.jpg"),
        require("@/assets/wxxcx/dt/dtdt.jpg"),
        require("@/assets/wxxcx/dt/dthd.jpg"),
        require("@/assets/wxxcx/dt/dtme.jpg"),
        require("@/assets/wxxcx/dt/dtsp.jpg"),
        require("@/assets/wxxcx/dt/dtxx.jpg"),
        require("@/assets/wxxcx/dt/dtxxsp.jpg"),
      ],
      detail:
        "「低碳游」是一款以低碳环保为核心理念的微信小程序，围绕用户日常低碳行为（到店打卡、拍照记录、旧物回收、学习低碳知识等）发放积分，积分可在商城兑换商品/券码，形成「行为 → 积分 → 权益」完整闭环。平台同时连接 C 端用户与 B 端商家，并提供团长分销能力。",
      highlights: [
        "行为激励闭环：低碳行为 → 积分 → 权益兑换",
        "地图化低碳打卡：LBS 地图标记、分类筛选、拍照/扫码打卡",
        "多角色一体化：普通用户 / 商家 / 团长 动态切换界面",
        "团长分销体系：申请团长、商品分销、分享海报、团队统计",
        "安全细节：首页截屏防护、到期全局提醒",
        "工程化：TDesign 组件库、按需加载、统一接口封装",
      ],
    },
    {
      name: "鲜锋到站",
      type: "微信小程序",
      desc: "面向训练场景的教练/学员端小程序，集签到、活动、订单、佣金分销于一体的教练运营工具。",
      tags: ["训练", "签到", "佣金分销", "活动报名"],
      client: "自营",
      year: "2026",
      img: require("@/assets/wxxcx/xf/xf1.png"),
      gallery: [
        require("@/assets/wxxcx/xf/xf1.png"),
        require("@/assets/wxxcx/xf/xf2.png"),
        require("@/assets/wxxcx/xf/xf3.png"),
        require("@/assets/wxxcx/xf/xf4.png"),
        require("@/assets/wxxcx/xf/xf5.png"),
        require("@/assets/wxxcx/xf/xf6.png"),
        require("@/assets/wxxcx/xf/xf7.png"),
        require("@/assets/wxxcx/xf/xf8.png"),
        require("@/assets/wxxcx/xf/xf9.png"),
        require("@/assets/wxxcx/xf/xf10.png"),
        require("@/assets/wxxcx/xf/xf11.png"),
        require("@/assets/wxxcx/xf/xf12.png"),
      ],
      detail:
        "鲜锋到站是一款面向训练场景的教练/学员端微信小程序，围绕教练/学员日常运营场景设计，覆盖上课签到、活动发布与报名、订单管理、佣金分销等核心流程。教练可在小程序内一键发布活动、签到学员、查看订单与佣金明细，学员端则可报名活动、领取优惠券、跟踪订单进度，形成「活动 → 报名 → 签到 → 订单 → 佣金」的完整业务闭环，帮助教练实现数字化招生与运营。",
      highlights: [
        "教练双端：教练首页与学员端协同，运营与报名一体",
        "上课签到：学员到场签到，课时记录自动归档",
        "活动管理：发布活动 → 报名 → 详情查看，全流程线上化",
        "订单与佣金：订单明细 + 佣金分销，收益一眼看清",
        "营销工具：优惠券发放与核销，提升报名转化",
        "个人中心：我的订单、佣金、活动统一入口",
      ],
    },
    {
      name: "旧衣帮",
      type: "微信小程序",
      desc: "旧衣物等闲置物品回收与流转小程序，支持在线申领衣物、预约上门回收、快递寄送与订单跟踪。",
      tags: ["旧物回收", "预约回收", "快递", "申领流转"],
      client: "旧衣帮",
      year: "2025",
      img: require("@/assets/wxxcx/jyb/1.png"),
      gallery: [
        require("@/assets/wxxcx/jyb/1.png"),
        require("@/assets/wxxcx/jyb/2.png"),
        require("@/assets/wxxcx/jyb/3.png"),
        require("@/assets/wxxcx/jyb/4.png"),
        require("@/assets/wxxcx/jyb/5.png"),
        require("@/assets/wxxcx/jyb/6.png"),
        require("@/assets/wxxcx/jyb/7.png"),
        require("@/assets/wxxcx/jyb/8.png"),
        require("@/assets/wxxcx/jyb/9.png"),
      ],
      detail:
        "旧衣帮是一款聚焦旧衣物等闲置物品回收与流转的微信小程序，围绕「申领-预约-回收-流转」构建公益+环保的业务闭环。用户可在小程序内浏览并申领可流转的衣物，填写地址后预约上门回收或选择快递寄送，订单全程状态可查（预约成功→已完成），并配套钱包明细、申领记录等账户能力，让旧物回收更便捷、可追溯。",
      highlights: [
        "旧物回收：衣物等闲置物品在线申领与流转",
        "预约上门：选择地址→预约回收→快递寄送灵活可选",
        "订单跟踪：预约成功 / 已完成 状态全程可见",
        "申领记录：我的申领历史一目了然",
        "钱包明细：收支流水清晰透明",
        "地址管理：多地址维护，预约回收更高效",
      ],
    },
    {
      name: "葵江米业",
      type: "微信小程序",
      desc: "粮油垂直电商商城小程序，集商品浏览下单、订单改价发货、经销商与代理分销管理于一体。",
      tags: ["粮油电商", "商城", "经销商", "代理分销"],
      client: "葵江粮油",
      year: "2024",
      img: require("@/assets/wxxcx/ly/葵江米业首页.png"),
      gallery: [
        require("@/assets/wxxcx/ly/葵江米业首页.png"),
        require("@/assets/wxxcx/ly/商品详情.png"),
        require("@/assets/wxxcx/ly/订单管理.png"),
        require("@/assets/wxxcx/ly/订单管理-改价发货弹窗.png"),
        require("@/assets/wxxcx/ly/退货.png"),
        require("@/assets/wxxcx/ly/选择退款方式.png"),
        require("@/assets/wxxcx/ly/经销商管理.png"),
        require("@/assets/wxxcx/ly/我的代理.png"),
      ],
      detail:
        "葵江粮油是一款面向粮油行业的垂直电商商城微信小程序，服务于葵江米业的线上销售与渠道管理。用户可在小程序内浏览粮油商品、查看商品详情并下单，商家端支持订单管理、改价与发货操作，并配套退货与多种退款方式选择。同时内置经销商管理与代理分销体系，实现「商品→订单→发货→售后→渠道」的完整电商业务闭环。",
      highlights: [
        "粮油商城：首页商品展示 + 商品详情 + 在线下单",
        "订单管理：订单列表 + 改价 + 发货弹窗一体化操作",
        "售后闭环：退货申请 + 多种退款方式灵活选择",
        "经销商管理：渠道商入驻与统一管理",
        "代理分销：我的代理体系，社交裂变获客",
        "垂直行业：聚焦粮油品类，供应链深度适配",
      ],
    },
    {
      name: "利园商城",
      type: "微信小程序",
      desc: "面向利园客户的综合电商商城小程序，覆盖商品浏览、下单支付、订单跟踪与会员管理等完整购物流程。",
      tags: ["电商商城", "在线下单", "订单跟踪", "会员"],
      client: "利园",
      year: "2024",
      img: require("@/assets/wxxcx/liyuan/1.png"),
      gallery: [
        require("@/assets/wxxcx/liyuan/1.png"),
        require("@/assets/wxxcx/liyuan/2.png"),
        require("@/assets/wxxcx/liyuan/3.png"),
        require("@/assets/wxxcx/liyuan/4.png"),
        require("@/assets/wxxcx/liyuan/5.png"),
        require("@/assets/wxxcx/liyuan/6.png"),
        require("@/assets/wxxcx/liyuan/7.png"),
        require("@/assets/wxxcx/liyuan/8.png"),
      ],
      detail:
        "利园商城是为利园客户打造的微信小程序电商商城，提供从商品浏览、加购下单到支付发货的全链路购物体验。用户可在小程序内浏览商品、查看详情、提交订单并完成支付，订单状态全程可跟踪，同时配套会员中心与个人账户能力，构建完整的「浏览→下单→支付→收货→复购」电商闭环。",
      highlights: [
        "商品浏览：首页推荐 + 分类导航 + 商品详情",
        "下单支付：加购下单 + 在线支付，流程顺滑",
        "订单跟踪：订单状态实时更新，收货进度可见",
        "会员中心：个人账户、订单历史统一管理",
        "移动优先：微信小程序即用即走，触达便捷",
        "完整闭环：浏览→下单→支付→收货→复购",
      ],
    },
    {
      name: "酷点租房",
      type: "微信小程序",
      desc: "面向留学生租房场景的小程序，集房源浏览筛选、线上预定订房、定金代付、续约、预约报修、活动与优惠券于一体。",
      tags: ["租房", "线上订房", "定金代付", "报修", "留学"],
      client: "酷点租房",
      year: "2024",
      img: require("@/assets/wxxcx/kd/酷点首页.png"),
      gallery: [
        require("@/assets/wxxcx/kd/酷点首页.png"),
        require("@/assets/wxxcx/kd/房源介绍 - 副本.png"),
        require("@/assets/wxxcx/kd/筛选弹窗.png"),
        require("@/assets/wxxcx/kd/酷点活动详情.png"),
        require("@/assets/wxxcx/kd/代付定金.png"),
        require("@/assets/wxxcx/kd/付款.png"),
        require("@/assets/wxxcx/kd/预约报修.png"),
        require("@/assets/wxxcx/kd/留学攻略.png"),
        require("@/assets/wxxcx/kd/完善个人信息.png"),
        require("@/assets/wxxcx/kd/我的.png"),
      ],
      detail:
        "酷点租房是一款面向留学生租房场景的微信小程序，围绕「找房→预定→订房→入住→报修→续约」构建完整租房服务闭环。用户可在首页浏览房源、通过筛选弹窗按条件找房、查看房源介绍与活动详情，支持线上预定订房、定金代付与付款操作；入住后可预约报修、续约，并配套留学攻略、优惠券与个人中心，让留学生租房更省心。",
      highlights: [
        "房源浏览：首页推荐 + 筛选弹窗 + 房源介绍详情",
        "线上订房：预定 → 代付定金 → 付款 全流程线上化",
        "活动与优惠：酷点活动详情 + 优惠券发放核销",
        "预约报修：线上预约维修，响应进度可跟踪",
        "续约管理：租期续约线上办理，提升留存",
        "留学生态：留学攻略 + 个人信息完善，贴近留学生场景",
      ],
    },
  ],
  industrial: [
    {
      name: "海上监测平台",
      type: "海洋物联",
      desc: "手持设备软件定位查看航道，实时检测巡查船只路径，发现问题智能记录坐标并上传平台。",
      tags: ["海洋物联", "航道巡检", "坐标回传"],
      client: "海洋监测站",
      year: "2022",
      img: require("@/assets/nanao/one.png"),
      gallery: [
        require("@/assets/nanao/one.png"),
        require("@/assets/nanao/tow.png"),
        require("@/assets/nanao/thress.png"),
      ],
      detail:
        "海上监测平台整合海洋监测设备与手持软件，实现航道巡查全流程数字化。巡查人员可通过手持设备软件定位查看行驶中的航道，实时检测巡查船只路径并记录，现场发现问题时监管人员记录拍照，系统将智能记录坐标并上传至平台，构建可追溯的海上巡查数据链路。",
      highlights: [
        "航道定位：实时查看航道与船只路径",
        "路径留痕：巡查航迹自动记录，可回放与统计",
        "现场记录：问题拍照 + 智能坐标回传平台",
        "数据汇聚：平台端多源数据一张图统一展示",
      ],
    },
    {
      name: "养殖区智慧平台",
      type: "农业物联",
      desc: "养殖区水质、气象、投喂设备物联接入与远程调度，物料分配-归纳-匹配-出库-包装全流程。",
      tags: ["物联", "远程调度", "水质监测"],
      client: "ABB",
      year: "2022",
      img: require("@/assets/one.png"),
      gallery: [require("@/assets/one.png")],
      detail:
        "养殖区智慧平台面向水产养殖场景，物联接入水质、气象、投喂设备，实现远程调度与数字化管理。物料从分配、归纳、匹配到出库、包装全流程跟踪，降低人工巡检成本，提升养殖效率与管理精度。",
      highlights: [
        "设备物联：水质 / 气象 / 投喂设备接入",
        "远程调度：现场设备远程控制与策略下发",
        "物料追溯：分配-归纳-匹配-出库-包装全流程",
        "预警告警：阈值自动告警与处置建议",
      ],
    },
    {
      name: "智慧路灯管理平台",
      type: "城市物联",
      desc: "接入深圳城市部分道路路灯，实现集中监控、远程开关、能耗统计与检修工单一体化管理。",
      tags: ["路灯", "远程控制", "工单"],
      client: "ABB",
      year: "2022",
      img: require("@/assets/one.png"),
      gallery: [require("@/assets/one.png")],
      detail:
        "智慧路灯管理平台接入深圳城市部分道路路灯，实现集成控制并进行检修管理，覆盖远程开关灯、亮度调节、运行状态监控、能耗统计、检修工单派发等一体化能力，提升市政路灯运维效率。",
      highlights: [
        "集中控制：远程开关、亮度策略统一管理",
        "实时监控：路灯运行状态与故障告警",
        "能耗统计：分路 / 分区能耗看板与对比",
        "检修工单：故障自动派发维修人员",
      ],
    },
    {
      name: "地平线",
      type: "智慧系统",
      desc: "智驾场景视频展示开发，展示驾驶场景下的视频内容。",
      tags: ["视频展示", "视频", "安全"],
      client: "地平线",
      year: "2020",
      img: require("@/assets/gyh/dpxzz/ty.png"),
      gallery: [
        require("@/assets/gyh/dpxzz/ty.png"),
        require("@/assets/gyh/dpxzz/zjbx.png"),
        require("@/assets/gyh/dpxzz/zjjs.png"),
        require("@/assets/gyh/dpxzz/zjsy.png"),
      ],
      detail:
        "地平线为智能驾驶场景下的视频展示，满足政务场景对安全合规、操作审计与易用性的要求。",
      highlights: [
        "视频展示：全场景全天候视频展示",
        "辅助驾驶系统：城区辅助驾驶系统",
      ],
    },
  ],
  custom: [
    {
      name: "志愿者之家",
      type: "志愿服务平台",
      desc: "面向志愿者与组织的志愿服务管理平台，集志愿者注册、活动发布报名、服务时长记录、组织管理与证书发放于一体。",
      tags: ["志愿者", "活动报名", "服务时长", "组织管理"],
      client: "文明办",
      year: "2024",
      img: require("@/assets/dzh/zyz/zyzsy.png"),
      gallery: [require("@/assets/dzh/zyz/zyzsy.png"),require("@/assets/dzh/zyz/sjz.png")],
      detail:
        "志愿者之家是一款面向志愿者与志愿服务组织的志愿服务管理平台，围绕「志愿者注册→活动报名→服务签到→时长记录→证书发放」构建完整志愿服务闭环。志愿者可在平台注册档案、浏览并报名志愿活动、现场签到累计服务时长；组织端可发布活动、审核报名、管理志愿者档案并发放服务证书，让志愿服务运营更规范、可追溯。",
      highlights: [
        "志愿者档案：注册信息 + 技能标签 + 服务历史",
        "活动管理：发布活动 → 报名审核 → 现场签到",
        "服务时长：签到/签退自动累计，记录可追溯",
        "组织管理：志愿组织入驻与志愿者统一调度",
        "证书发放：服务时长达标自动发放电子证书",
        "数据看板：志愿者规模、活动场次、服务总时长统计",
      ],
    },
    {
      name: '海警网',
      type: "新闻公告门户",
      desc: "面向武警海警的海警网新闻公告门户，发布时政要闻、海警动态、政策法规与学习专栏等内容。",
      tags: ["新闻公告", "门户", "海警"],
      client: "武警海警",
      year: "2025",
      img: require("@/assets/dzh/hj/hj.png"),
      gallery: [
        require("@/assets/dzh/hj/hj.png"),
      ],
      detail:
        '强军网是面向武警海警部队的新闻公告类门户网站，围绕时政要闻、海警动态、政策法规、学习教育等栏目，构建权威、及时、规范的强军宣传与资讯发布阵地。网站支持图文新闻发布、公告通知、专题专栏与学习资料管理，为海警官兵提供一站式资讯与学习入口。',
      highlights: [
        "新闻发布：时政要闻 / 海警动态 图文资讯实时发布",
        "公告通知：通知公告与政策法规专栏，规范传达",
        "学习专栏：学习教育资料集中沉淀，便于官兵查阅",
        "专题专栏：围绕重大主题构建专题聚合页",
        "门户架构：多栏目导航 + 检索，资讯一站触达",
        "安全合规：面向部队场景的内容审核与权限管控",
      ],
    },
    {
      name: '"智慧监管平台"',
      type: "数据中台",
      desc: "商户口罩识别、厨师帽识别、抽烟识别、老鼠识别等AI事件自动派单至商户负责人闭环处置。",
      tags: ["AI识别", "视频分析", "派单闭环"],
      client: "食药监",
      year: "2023",
      img: require("@/assets/gaoxin/one.png"),
      gallery: [
        require("@/assets/gaoxin/one.png"),
        require("@/assets/gaoxin/tow.png"),
        require("@/assets/gaoxin/thress.png"),
      ],
      detail:
        '"智慧监管平台"面向商户食品安全监管场景，接入商户配餐区、洗料区、熟食区监控视频，通过AI算法自动识别口罩佩戴、厨师帽、抽烟、老鼠等违规事件，识别结果以派单形式下发商户负责人闭环处置，有效降低人工巡查成本，提升监管响应速度。',
      highlights: [
        "多路AI识别：口罩 / 厨师帽 / 抽烟 / 老鼠 多场景识别",
        "商户分级派单：按区域与商户负责人自动分拨",
        "处置闭环跟踪：整改时效、复核留痕、预警统计",
        "商户端协同：负责人小程序接收 / 上传整改凭证",
      ],
    },
    {
      name: "利园校服",
      type: "校服定制平台",
      desc: "面向校服企业的校服定制与供应管理平台，覆盖校服设计、班级批量下单、尺码试穿、生产排期与售后一体化的校服服务系统。",
      tags: ["校服定制", "批量下单", "尺码试穿", "供应管理"],
      client: "利园校服",
      year: "2024",
      img: require("@/assets/dzh/ly/ly.png"),
      gallery: [require("@/assets/dzh/ly/ly.png")],
      detail:
        "利园校服是一款面向校服企业的校服定制与供应管理平台，围绕「学校下单→班级尺码统计→试穿→生产排期→交付→售后」构建完整校服服务闭环。学校端可按班级/年级批量下单、汇总学生尺码，企业端支持校服设计、生产排期、库存调度与售后换补，让校服供应更规范、可追溯。",
      highlights: [
        "校服定制：款式设计 / 面料选择 / 校徽刺绣个性化",
        "班级批量下单：按班级年级统计尺码，集中下单",
        "试穿管理：学生试穿尺码登记与调整",
        "生产排期：订单汇总→生产排程→交付跟踪",
        "库存调度：款式/尺码库存统一管理与调配",
        "售后换补：尺码换补 / 补订，售后闭环可追溯",
      ],
    },
    {
      name: "汕头市革命历史博物馆",
      type: "数字博物馆",
      desc: "汕头市革命历史博物馆数字化展示与教育平台，集线上展厅、革命历史教育、参观预约与科普传播于一体的红色文化阵地。",
      tags: ["数字博物馆", "线上展厅", "革命教育", "参观预约"],
      client: "汕头市革命历史博物馆",
      year: "2024",
      img: require("@/assets/dzh/gmls/sy.png"),
      gallery: [
        require("@/assets/dzh/gmls/sy.png"),
        require("@/assets/dzh/gmls/xsdt.png"),
        require("@/assets/dzh/gmls/cgtj.png"),
        require("@/assets/dzh/gmls/ggjy.png"),
        require("@/assets/dzh/gmls/kp.png"),
      ],
      detail:
        "汕头市革命历史博物馆数字化展示与教育平台，围绕「线上展厅→革命教育→参观预约→科普传播」构建红色文化服务闭环。平台支持线上 3D 展厅漫游、革命历史图文与多媒体教育内容、参观预约与导览、科普知识传播，让革命历史走出馆舍，触达更多公众与青少年，打造永不落幕的红色文化阵地。",
      highlights: [
        "线上展厅：3D 虚拟展厅漫游，文物展品数字化呈现",
        "革命教育：革命历史图文/多媒体教育内容沉淀",
        "参观预约：在线预约 + 导览路线，提升参观体验",
        "科普传播：革命历史科普知识，面向青少年群体",
        "红色文化：汕头地方革命史与红色记忆传承",
        "多端触达：PC + 移动端，永不落幕的数字博物馆",
      ],
    },
    
  ],
  app: [
    {
      name: "潮汕高铁出行服务",
      type: "移动应用",
      desc: "面向高铁出行场景的移动服务应用，提供旅客下车后的站内/出站导航与高铁购票、改签、退票等终点站服务，构建出行闭环。",
      tags: ["高铁出行", "下车导航", "购票", "出行服务"],
      client: "潮汕铁路",
      year: "2023",
      img: require("@/assets/app/csdft/1.png"),
      gallery: [
        require("@/assets/app/csdft/1.png"),
        require("@/assets/app/csdft/2.png"),
        require("@/assets/app/csdft/3.png"),
        require("@/assets/app/csdft/4.png"),
      ],
      detail:
        "潮汕高铁出行服务APP是面向高铁旅客的移动服务应用，围绕「下车导航 + 购票服务」构建旅客出行闭环。旅客到站下车后可通过APP获取站内导航（候车室、出站口、换乘通道）与出站后的周边导航；同时APP提供到达/始发本站的高铁购票、改签、退票等终点站服务，让旅客从购票到下车出行全程线上化，提升出行体验。",
      highlights: [
        "下车导航：站内候车室 / 出站口 / 换乘通道导航",
        "出站导航：出站后周边交通与目的地路线指引",
        "购票服务：到达 / 始发本站高铁购票一站办理",
        "改签退票：车票改签、退票线上办理",
        "到站提醒：到站提醒 + 换乘指引，行程不误点",
        "出行闭环：购票 → 乘车 → 下车导航 → 目的地，全程覆盖",
      ],
    },
    {
      name: "百家姓",
      type: "文化导览应用",
      desc: "百家姓博物馆移动导览应用，提供博物馆介绍、馆内平面图与参观路线、姓氏来源与文化解读等内容。",
      tags: ["博物馆导览", "平面图", "姓氏文化", "参观路线"],
      client: "南方电网",
      year: "2023",
      img: require("@/assets/app/bjx/sy.png"),
      gallery: [
        require("@/assets/app/bjx/sy.png"),
        require("@/assets/app/bjx/gg.png"),
        require("@/assets/app/bjx/lb.png"),
        require("@/assets/app/bjx/hb.png"),
        require("@/assets/app/bjx/lxt.png"),
      ],
      detail:
        "百家姓是一款面向百家姓博物馆的移动导览与姓氏文化展示应用，围绕「博物馆介绍→平面图路线→姓氏来源→文化解读」构建参观与学习闭环。用户可在APP内浏览博物馆概况、查看馆内平面图与推荐参观路线、了解各展厅布局；同时提供姓氏来源、迁徙演变与文化故事等内容，让访客线上预览、线下导览、文化溯源一站完成。",
      highlights: [
        "博物馆介绍：馆况概况 / 展厅分布 / 开放信息",
        "平面图路线：馆内平面图 + 推荐参观路线指引",
        "姓氏来源：百家姓起源 / 迁徙演变 / 文化故事",
        "展厅导览：分展厅图文与多媒体解读",
        "参观闭环：线上预览 → 线下导览 → 文化溯源",
        "多端触达：移动端导览 + 馆内大屏联动",
      ],
    },
    {
      name: "海洋监测终端",
      type: "现场终端",
      desc: "海上站点现场数据查看与设备控制的专用终端应用。",
      tags: ["终端", "控制", "海洋"],
      client: "海洋监测站",
      year: "2022",
      img:  require("@/assets/zwtp.jpg"),
    },
    {
      name: "产线工位终端",
      type: "工位应用",
      desc: "产线工位扫码作业、工序指引与异常上报的专用工位终端。",
      tags: ["工位", "扫码", "工序"],
      client: "某标签包装企业",
      year: "2022",
      img:  require("@/assets/zwtp.jpg"),
    },
    {
      name: "养殖户移动端",
      type: "移动应用",
      desc: "养殖户手机查看水质气象、接收预警与远程投喂控制的移动应用。",
      tags: ["移动", "预警", "远程控制"],
      client: "某水产养殖企业",
      year: "2021",
      img: require("@/assets/zwtp.jpg")
    },
    {
      name: "园区访客APP",
      type: "公众应用",
      desc: "访客预约、通行、消费与活动参与的园区公众移动应用。",
      tags: ["公众", "预约", "通行"],
      client: "广州国际生物岛",
      year: "2021",
      img: require("@/assets/zwtp.jpg"),
    },
  ],
};
